import { render, staticRenderFns } from "./theNameResult.vue?vue&type=template&id=344fe58a&scoped=true&"
import script from "./theNameResult.vue?vue&type=script&lang=js&"
export * from "./theNameResult.vue?vue&type=script&lang=js&"
import style0 from "./theNameResult.vue?vue&type=style&index=0&id=344fe58a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344fe58a",
  null
  
)

export default component.exports